import { RESPONSE_STATUS, CLEAR_RESPONSE, GET_ALL_COUPONS } from './couponTypes'
export default (state, action) => {
    switch (action.type) {
        case GET_ALL_COUPONS:
            return {
                ...state,
                search_allcoupons: action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }

        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
